import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  ${({ usePadding }) =>
    usePadding &&
    css`
      padding: ${usePadding};
    `}
`;

export const InputSelectedBox = styled.i.attrs(({ checked }) => ({
  className: checked ? 'fa-solid fa-check' : '',
}))`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.white};
`;

export const InputSelectedRadio = styled.div`
  position: absolute;
  top: 0px;
  border-radius: 50%;
  height: 13px;
  width: 13px;
  min-height: 13px;
  min-width: 13px;
  ${({ checked, theme }) =>
    checked &&
    css`
      background: ${theme.selectionBox.checked.color};
      border: 2px solid ${theme.selectionBox.background};
    `}
`;

export const InputSelectionBox = styled.button`
  ${({ disabled, radio }) => css`
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    background: ${({ theme }) => theme.selectionBox.background};
    border-radius: ${radio ? '50%' : '2px'};
  `};
  appearance: none;
  position: relative;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 17px;
  width: 17px;
  min-height: 17px;
  min-width: 17px;
  margin-top: 3px;
  border: 2px solid ${({ theme }) => theme.selectionBox.border};
  ${({ checked, theme }) => {
    return (
      checked &&
      css`
        background: ${theme.selectionBox.checked.color};
        border: 2px solid ${theme.selectionBox.checked.border};
      `
    );
  }}
`;

export const InputLabel = styled.label`
  ${({ disabled, theme }) => {
    const color = disabled ? theme.selectionBox.disabled.label : theme.selectionBox.label;
    return css`
      color: ${color};
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    `;
  }};
  font-weight: 400;
  margin-left: 8px;
  margin-bottom: 0px;
  font-size: 15px;
`;
